import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Typography, useTheme } from '@mui/material';

const Header = () => {
  const theme = useTheme();
  const location = useLocation();

  const pageTitles = {
    '/dashboard': 'Dashboard',
    '/reports': 'Reports',
    '/userregistry': 'User Registry',
    '/semester': 'Semester',
    '/preferences': 'Preferences',
  };

  const pageTitle = pageTitles[location.pathname] || 'SMART LAB';

  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        p: 3,
        m: 5,
        mt: '33px',
        pl: '40px',
        borderRadius: '15px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontFamily: '"Space Grotesk", sans-serif',
          fontWeight: 600,
          color: '#130f72',
        }}
      >
        {pageTitle}
      </Typography>
    </Box>
  );
};

export default Header;